module.exports = __webpack_public_path__ + "img/main_board.05fffe44.jpg";